import {
  singleOrNullrknfaxokm1sl as singleOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './ContainingView.commonHtml.mjs';
import {
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
  Duration5ynfiptaqcrg as Duration,
  Duration__times_impl_sfuzvp2ze3ly07zbx9v as Duration__times_impl_sfuzvp,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { toNumber2e2hj9zugjwi2 as toNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  until1jbpn0z3f8lbg as until,
  downTo39qhfeycepm1j as downTo,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { asSequence2lno4vpru4ldl as asSequence_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  filter184huxd00uyfg as filter,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_showHideAnimating() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return showHideAnimating;
}
var showHideAnimating;
function set_showHideQueue(_set____db54di) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  showHideQueue = _set____db54di;
}
function get_showHideQueue() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return showHideQueue;
}
var showHideQueue;
function get_log() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return log;
}
var log;
function get_showHideWorker() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  return showHideWorker;
}
var showHideWorker;
function OngoingAnimation$play$lambda(it) {
  var tmp0_safe_receiver = singleOrNull(it.oba());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fb9();
  return tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
}
function OngoingAnimation$done$lambda$lambda(it) {
  var tmp0_safe_receiver = singleOrNull(it.oba());
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fb9();
  return tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
}
var OngoingAnimationClass;
function OngoingAnimation() {
  if (OngoingAnimationClass === VOID) {
    class $ {
      constructor(on, from, to, goal, startRatio) {
        this.udq_1 = on;
        this.vdq_1 = from;
        this.wdq_1 = to;
        this.xdq_1 = goal;
        this.ydq_1 = startRatio;
        this.zdq_1 = 1000.0;
        var tmp = this;
        var tmp_0 = this.udq_1.tb5_1.vb3_1;
        tmp.adr_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        var tmp_1 = this;
        var tmp_2 = this.udq_1.oba().q1(0).tb5_1.vb3_1;
        tmp_1.bdr_1 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
        this.cdr_1 = null;
        this.ddr_1 = '';
        this.edr_1 = '';
        this.fdr_1 = '';
        this.gdr_1 = '';
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp1_safe_receiver = singleOrNull(this.udq_1.oba());
          tmp0_safe_receiver.abn(['QueuedAnimation: ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fb9()) + ' / ' + this.xdq_1 + ': ' + JSON.stringify(this.vdq_1) + ' -> ' + JSON.stringify(this.wdq_1)]);
        }
        this.hdr_1 = false;
        var tmp_3 = this;
        tmp_3.idr_1 = () => {
          var tmp;
          if (this.hdr_1) {
            return Unit_instance;
          }
          this.hdr_1 = true;
          get_showHideAnimating().t3(this.udq_1);
          var tmp0_safe_receiver = get_log();
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp_0 = get_showHideAnimating().q3();
            tmp0_safe_receiver.fcv(['showHideAnimating: ' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, OngoingAnimation$done$lambda$lambda)]);
          }
          this.adr_1.hidden = !this.xdq_1;
          var tmp_1 = this.udq_1.rb6_1;
          var tmp1_safe_receiver = tmp_1 instanceof RowOrCol() ? tmp_1 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.vb8();
          }
          this.adr_1.classList.remove('animatingShowHide');
          this.bdr_1.style.width = '100%';
          this.bdr_1.style.removeProperty('maxWidth');
          this.bdr_1.style.height = '100%';
          this.bdr_1.style.removeProperty('maxHeight');
          return Unit_instance;
        };
      }
      jdr() {
        return ensureNotNull(this.cdr_1).currentTime / this.zdq_1;
      }
      kdr() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp1_safe_receiver = singleOrNull(this.udq_1.oba());
          tmp0_safe_receiver.abn(['Starting animation on ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fb9())]);
        }
        this.adr_1.hidden = false;
        this.zdq_1 = toNumber(_Duration___get_inWholeMilliseconds__impl__msfiry(this.udq_1.kba().tb0_1));
        var tmp = this;
        var tmp_0 = this.udq_1.tb5_1.vb3_1;
        var tmp0 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp2 = [this.vdq_1, this.wdq_1];
        // Inline function 'com.lightningkite.kiteui.views.direct.animate' call
        var options = json([to('duration', this.zdq_1), to('easing', 'linear')]);
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = tmp0.animate(tmp2, options);
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp_1 == null) ? !(tmp_1 == null) : false) ? tmp_1 : THROW_CCE();
        // Inline function 'kotlin.also' call
        var this_1 = this.ydq_1 * this.zdq_1;
        var tmp0_safe_receiver_0 = get_log();
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.abn(['Starting at ' + this_1]);
        }
        this_0.currentTime = this_1;
        this_0.onfinish = (it) => {
          this.idr_1();
          return Unit_instance;
        };
        this_0.oncancel = (it) => {
          this.idr_1();
          return Unit_instance;
        };
        this_0.onremove = (it) => {
          this.idr_1();
          return Unit_instance;
        };
        tmp.cdr_1 = this_0;
        this.adr_1.classList.add('animatingShowHide');
        var tmp0_0 = get_showHideAnimating();
        // Inline function 'kotlin.collections.set' call
        var key = this.udq_1;
        tmp0_0.s3(key, this);
        var tmp2_safe_receiver = get_log();
        if (tmp2_safe_receiver == null)
          null;
        else {
          var tmp_2 = get_showHideAnimating().q3();
          tmp2_safe_receiver.fcv(['showHideAnimating: ' + joinToString(tmp_2, VOID, VOID, VOID, VOID, VOID, OngoingAnimation$play$lambda)]);
        }
      }
      lai() {
        ensureNotNull(this.cdr_1).finish();
        this.idr_1();
      }
      ldr() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['pretendEnd']);
        }
        ensureNotNull(this.cdr_1).pause();
        this.adr_1.hidden = !this.xdq_1;
        this.ddr_1 = this.bdr_1.style.width;
        this.edr_1 = this.bdr_1.style.maxWidth;
        this.fdr_1 = this.bdr_1.style.height;
        this.gdr_1 = this.bdr_1.style.maxHeight;
        this.bdr_1.style.width = '100%';
        this.bdr_1.style.removeProperty('maxWidth');
        this.bdr_1.style.height = '100%';
        this.bdr_1.style.removeProperty('maxHeight');
      }
      mdr() {
        var tmp0_safe_receiver = get_log();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['continueNow']);
        }
        this.adr_1.hidden = false;
        this.bdr_1.style.width = this.ddr_1;
        this.bdr_1.style.maxWidth = this.edr_1;
        this.bdr_1.style.height = this.fdr_1;
        this.bdr_1.style.maxHeight = this.gdr_1;
        ensureNotNull(this.cdr_1).play();
      }
      toString() {
        return 'OngoingAnimation(on=' + this.udq_1.toString() + ', from=' + toString(this.vdq_1) + ', to=' + toString(this.wdq_1) + ', goal=' + this.xdq_1 + ', startRatio=' + this.ydq_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.udq_1);
        result = imul(result, 31) + hashCode(this.vdq_1) | 0;
        result = imul(result, 31) + hashCode(this.wdq_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.xdq_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.ydq_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OngoingAnimation()))
          return false;
        if (!equals(this.udq_1, other.udq_1))
          return false;
        if (!equals(this.vdq_1, other.vdq_1))
          return false;
        if (!equals(this.wdq_1, other.wdq_1))
          return false;
        if (!(this.xdq_1 === other.xdq_1))
          return false;
        if (!equals(this.ydq_1, other.ydq_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OngoingAnimation');
    OngoingAnimationClass = $;
  }
  return OngoingAnimationClass;
}
function nativeAnimateShow(_this__u8e3s4) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp0_safe_receiver = get_log();
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_safe_receiver = singleOrNull(_this__u8e3s4.oba());
    tmp0_safe_receiver.abn(['' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fb9()) + '.nativeAnimateShow']);
  }
  var tmp2_elvis_lhs = get_showHideQueue();
  var tmp;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    var newMap = HashMap().n8();
    set_showHideQueue(newMap);
    window.setTimeout(get_showHideWorker(), 32);
    tmp = newMap;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  tmp.s3(_this__u8e3s4, true);
}
function nativeAnimateHide(_this__u8e3s4) {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  var tmp0_safe_receiver = get_log();
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_safe_receiver = singleOrNull(_this__u8e3s4.oba());
    tmp0_safe_receiver.abn(['' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fb9()) + '.nativeAnimateHide']);
  }
  var tmp2_elvis_lhs = get_showHideQueue();
  var tmp;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    var newMap = HashMap().n8();
    set_showHideQueue(newMap);
    window.setTimeout(get_showHideWorker(), 32);
    tmp = newMap;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  tmp.s3(_this__u8e3s4, false);
}
function showHideWorker$lambda() {
  _init_properties_modifiers_commonHtml_js_kt__3eylqb();
  // Inline function 'kotlin.run' call
  var it = get_showHideQueue();
  set_showHideQueue(null);
  var tmp;
  if (it == null) {
    return Unit_instance;
  } else {
    tmp = it;
  }
  var showHideQueue = tmp;
  var delayLevel = null;
  var tmp_0 = get_AppScope();
  launch(tmp_0, VOID, VOID, showHideWorker$lambda$slambda_0(showHideQueue, delayLevel));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp0_safe_receiver = get_log();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.abn(['//////////////////////////////////////////']);
  }
  var tmp1_safe_receiver = get_log();
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.abn(['Queued: ' + $this.ndr_1.p1()]);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_showHideAnimating().d2();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = to(item.e2(), item.f2());
    destination.v(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp;
    if ($this.ndr_1.q3().t1(element.af_1)) {
      var tmp0_safe_receiver_0 = get_log();
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp1_safe_receiver_0 = singleOrNull(element.af_1.oba());
        tmp0_safe_receiver_0.abn(['Cancelling animation on ' + (tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.fb9())]);
      }
      var r = to(element.af_1, element.bf_1.jdr());
      element.bf_1.lai();
      tmp = r;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver_1 = tmp;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.v(tmp0_safe_receiver_1);
    }
  }
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_1 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_0 = _iterator__ex2g4s_1.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    destination_1.s3(element_0.af_1, element_0.bf_1);
  }
  var pastRatios = destination_1;
  var tmp_0 = $this.ndr_1.q3();
  removeAll(tmp_0, showHideWorker$lambda$slambda$lambda);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = $this.ndr_1.d2().m1();
  while (_iterator__ex2g4s_2.n1()) {
    var element_1 = _iterator__ex2g4s_2.o1();
    var tmp0_safe_receiver_2 = get_log();
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      var tmp1_safe_receiver_1 = singleOrNull(element_1.e2().oba());
      tmp0_safe_receiver_2.abn(['  View ' + (tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.fb9()) + ' -> ' + element_1.f2()]);
    }
  }
  var tmp2_safe_receiver = get_log();
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.abn(['// Lock current sizes for views that are disappearing.']);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_3 = $this.ndr_1.d2().m1();
  while (_iterator__ex2g4s_3.n1()) {
    var element_2 = _iterator__ex2g4s_3.o1();
    $l$block: {
      // Inline function 'kotlin.collections.component1' call
      var on = element_2.e2();
      // Inline function 'kotlin.collections.component2' call
      var goal = element_2.f2();
      if (goal) {
        break $l$block;
      }
      var tmp_1 = on.tb5_1.vb3_1;
      var myElement = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
      var tmp_2 = on.oba().q1(0).tb5_1.vb3_1;
      var child = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
      child.style.width = myElement.clientWidth.toString() + 'px';
      child.style.maxWidth = 'unset';
      child.style.height = myElement.clientHeight.toString() + 'px';
      child.style.maxHeight = 'unset';
    }
  }
  var tmp_3 = asSequence_0($this.ndr_1);
  // Inline function 'kotlin.sequences.associate' call
  var tmp0 = filter(tmp_3, showHideWorker$lambda$slambda$lambda_0);
  // Inline function 'kotlin.sequences.associateTo' call
  var destination_2 = LinkedHashMap().f6();
  var _iterator__ex2g4s_4 = tmp0.m1();
  while (_iterator__ex2g4s_4.n1()) {
    var element_3 = _iterator__ex2g4s_4.o1();
    var tmp_4 = element_3.e2();
    var tmp_5 = window;
    var tmp_6 = element_3.e2().tb5_1.vb3_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(tmp_4, tmp_5.getComputedStyle(tmp_6 instanceof HTMLElement ? tmp_6 : THROW_CCE()).display);
    destination_2.s3(pair.af_1, pair.bf_1);
  }
  var displayValuesPreHide = destination_2;
  var tmp3_safe_receiver = $this.odr_1;
  var tmp_7 = tmp3_safe_receiver;
  if ((tmp_7 == null ? null : new (Duration())(tmp_7)) == null)
    null;
  else {
    var tmp_8 = tmp3_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_8 == null ? null : new (Duration())(tmp_8)).nj_1;
    var tmp_9 = delay(it, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
  }
  var tmp4_safe_receiver = get_log();
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.abn(['// Get the whole layout into the goal state for measurement.']);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_5 = get_showHideAnimating().d2().m1();
  while (_iterator__ex2g4s_5.n1()) {
    var element_4 = _iterator__ex2g4s_5.o1();
    element_4.f2().ldr();
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this.ndr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList().u(this_1.p1());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_6 = this_1.d2().m1();
  while (_iterator__ex2g4s_6.n1()) {
    var item_0 = _iterator__ex2g4s_6.o1();
    var tmp_10 = item_0.e2().tb5_1.vb3_1;
    var was = (tmp_10 instanceof HTMLElement ? tmp_10 : THROW_CCE()).hidden;
    var tmp_11 = item_0.e2().tb5_1.vb3_1;
    (tmp_11 instanceof HTMLElement ? tmp_11 : THROW_CCE()).hidden = !item_0.f2();
    var tmp_12 = item_0.e2().rb6_1;
    var tmp0_safe_receiver_3 = tmp_12 instanceof RowOrCol() ? tmp_12 : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      tmp0_safe_receiver_3.vb8();
    }
    var tmp1_safe_receiver_2 = get_log();
    if (tmp1_safe_receiver_2 == null)
      null;
    else {
      var tmp2_safe_receiver_0 = singleOrNull(item_0.e2().oba());
      tmp1_safe_receiver_2.abn(['View ' + (tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.fb9()) + ' -> ' + item_0.f2()]);
    }
    var tmp$ret$32 = to(item_0.e2(), was);
    destination_3.v(tmp$ret$32);
  }
  var beforeVisibility = destination_3;
  var tmp5_safe_receiver = $this.odr_1;
  var tmp_13 = tmp5_safe_receiver;
  if ((tmp_13 == null ? null : new (Duration())(tmp_13)) == null)
    null;
  else {
    var tmp_14 = tmp5_safe_receiver;
    // Inline function 'kotlin.let' call
    var it_0 = (tmp_14 == null ? null : new (Duration())(tmp_14)).nj_1;
    var tmp_15 = delay(Duration__times_impl_sfuzvp(it_0, 4), $completion);
    if (tmp_15 === get_COROUTINE_SUSPENDED())
      tmp_15 = yield tmp_15;
  }
  var tmp6_safe_receiver = get_log();
  if (tmp6_safe_receiver == null)
    null;
  else {
    tmp6_safe_receiver.abn(['// Lock current sizes for views that are appearing.']);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_7 = $this.ndr_1.d2().m1();
  while (_iterator__ex2g4s_7.n1()) {
    var element_5 = _iterator__ex2g4s_7.o1();
    $l$block_0: {
      // Inline function 'kotlin.collections.component1' call
      var on_0 = element_5.e2();
      // Inline function 'kotlin.collections.component2' call
      var goal_0 = element_5.f2();
      if (!goal_0) {
        break $l$block_0;
      }
      var tmp_16 = on_0.tb5_1.vb3_1;
      var myElement_0 = tmp_16 instanceof HTMLElement ? tmp_16 : THROW_CCE();
      var tmp_17 = on_0.oba().q1(0).tb5_1.vb3_1;
      var child_0 = tmp_17 instanceof HTMLElement ? tmp_17 : THROW_CCE();
      child_0.style.width = myElement_0.clientWidth.toString() + 'px';
      child_0.style.maxWidth = 'unset';
      child_0.style.height = myElement_0.clientHeight.toString() + 'px';
      child_0.style.maxHeight = 'unset';
      var tmp0_safe_receiver_4 = get_log();
      if (tmp0_safe_receiver_4 == null)
        null;
      else {
        var tmp1_safe_receiver_3 = singleOrNull(on_0.oba());
        tmp0_safe_receiver_4.abn(['  View ' + (tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3.fb9()) + ' appearing locked to ' + myElement_0.clientWidth + 'px x ' + myElement_0.clientHeight + 'px']);
      }
    }
  }
  var tmp7_safe_receiver = $this.odr_1;
  var tmp_18 = tmp7_safe_receiver;
  if ((tmp_18 == null ? null : new (Duration())(tmp_18)) == null)
    null;
  else {
    var tmp_19 = tmp7_safe_receiver;
    // Inline function 'kotlin.let' call
    var it_1 = (tmp_19 == null ? null : new (Duration())(tmp_19)).nj_1;
    var tmp_20 = delay(it_1, $completion);
    if (tmp_20 === get_COROUTINE_SUSPENDED())
      tmp_20 = yield tmp_20;
  }
  var tmp8_safe_receiver = get_log();
  if (tmp8_safe_receiver == null)
    null;
  else {
    tmp8_safe_receiver.abn(['// Queue the animations.']);
  }
  // Inline function 'kotlin.collections.map' call
  var this_2 = $this.ndr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList().u(this_2.p1());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_8 = this_2.d2().m1();
  while (_iterator__ex2g4s_8.n1()) {
    var item_1 = _iterator__ex2g4s_8.o1();
    // Inline function 'kotlin.collections.component1' call
    var on_1 = item_1.e2();
    // Inline function 'kotlin.collections.component2' call
    var goal_1 = item_1.f2();
    var tmp_21 = on_1.tb5_1.vb3_1;
    var myElement_1 = tmp_21 instanceof HTMLElement ? tmp_21 : THROW_CCE();
    var tmp_22 = on_1.oba().q1(0).tb5_1.vb3_1;
    var child_1 = tmp_22 instanceof HTMLElement ? tmp_22 : THROW_CCE();
    var tmp_23 = ensureNotNull(on_1.rb6_1).tb5_1.vb3_1;
    var parent = tmp_23 instanceof HTMLElement ? tmp_23 : THROW_CCE();
    var myStyle = window.getComputedStyle(myElement_1);
    var childStyle = window.getComputedStyle(child_1);
    var parentStyle = window.getComputedStyle(parent);
    var tmp_24;
    if (parentStyle.display === 'grid' || (parentStyle.display === 'flex' && contains(parentStyle.flexDirection, 'row'))) {
      tmp_24 = true;
    } else {
      var tmp_25;
      if (!(parentStyle.display === 'flex')) {
        var tmp0_elvis_lhs = displayValuesPreHide.p3(on_1);
        tmp_25 = contains(tmp0_elvis_lhs == null ? myStyle.display : tmp0_elvis_lhs, 'inline');
      } else {
        tmp_25 = false;
      }
      tmp_24 = tmp_25;
    }
    var x = tmp_24;
    var tmp_26;
    if (parentStyle.display === 'grid' || (parentStyle.display === 'flex' && contains(parentStyle.flexDirection, 'column'))) {
      tmp_26 = true;
    } else {
      var tmp_27;
      if (!(parentStyle.display === 'flex')) {
        var tmp1_elvis_lhs = displayValuesPreHide.p3(on_1);
        // Inline function 'kotlin.let' call
        var it_2 = tmp1_elvis_lhs == null ? myStyle.display : tmp1_elvis_lhs;
        tmp_27 = (contains(it_2, 'block') && !contains(it_2, 'inline'));
      } else {
        tmp_27 = false;
      }
      tmp_26 = tmp_27;
    }
    var y = tmp_26;
    // Inline function 'kotlin.takeIf' call
    var this_3 = myStyle.flexGrow;
    var tmp_28;
    var tmp_29;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(this_3)) {
      tmp_29 = !(this_3 === '0');
    } else {
      tmp_29 = false;
    }
    if (tmp_29) {
      tmp_28 = this_3;
    } else {
      tmp_28 = null;
    }
    var weighted = tmp_28;
    var usingFlexGap = parentStyle.display === 'flex';
    var before = {};
    var after = {};
    var full = goal_1 ? after : before;
    var fullTransform = ArrayList().w();
    var gone = goal_1 ? before : after;
    var goneTransform = ArrayList().w();
    if (x) {
      goneTransform.v('scaleX(0)');
      fullTransform.v('scaleX(1)');
      if (usingFlexGap) {
        var gapX = parentStyle.columnGap;
        gone.marginLeft = 'calc(' + gapX + ' / -2.0)';
        gone.paddingLeft = '0px';
        gone.marginRight = 'calc(' + gapX + ' / -2.0)';
        gone.paddingRight = '0px';
      } else {
        var gap = parentStyle.columnGap;
        var tmp_30;
        var tmp_31;
        if (parent.classList.contains('optimized')) {
          var tmp_32 = asSequence(until(0, parent.children.length));
          // Inline function 'kotlin.sequences.find' call
          var tmp0_0 = mapNotNull(tmp_32, showHideWorker$lambda$slambda$lambda_1(parent));
          var tmp$ret$53;
          $l$block_1: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s_9 = tmp0_0.m1();
            while (_iterator__ex2g4s_9.n1()) {
              var element_6 = _iterator__ex2g4s_9.o1();
              if (!element_6.hidden) {
                tmp$ret$53 = element_6;
                break $l$block_1;
              }
            }
            tmp$ret$53 = null;
          }
          var tmp$ret$54 = tmp$ret$53;
          tmp_31 = !equals(tmp$ret$54, myElement_1);
        } else {
          tmp_31 = false;
        }
        if (tmp_31) {
          var tmp_33 = asSequence(downTo(parent.children.length - 1 | 0, 0));
          // Inline function 'kotlin.sequences.find' call
          var tmp0_1 = mapNotNull(tmp_33, showHideWorker$lambda$slambda$lambda_2(parent));
          var tmp$ret$56;
          $l$block_2: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s_10 = tmp0_1.m1();
            while (_iterator__ex2g4s_10.n1()) {
              var element_7 = _iterator__ex2g4s_10.o1();
              if (!element_7.hidden) {
                tmp$ret$56 = element_7;
                break $l$block_2;
              }
            }
            tmp$ret$56 = null;
          }
          var tmp$ret$57 = tmp$ret$56;
          tmp_30 = equals(tmp$ret$57, myElement_1);
        } else {
          tmp_30 = false;
        }
        var doPrevMargin = tmp_30;
        if (doPrevMargin) {
          full.marginLeft = gap;
          gone.marginLeft = '0px';
        }
        gone.marginRight = '0px';
        gone.paddingRight = '0px';
      }
      if (weighted == null) {
        var fullWidth = childStyle.width;
        gone.width = '0px';
        gone.minWidth = '0px';
        gone.maxWidth = '0px';
        full.width = fullWidth;
        full.minWidth = fullWidth;
        full.maxWidth = fullWidth;
      }
    }
    if (y) {
      goneTransform.v('scaleY(0)');
      fullTransform.v('scaleY(1)');
      if (usingFlexGap) {
        var gapY = parentStyle.columnGap;
        gone.marginTop = 'calc(' + gapY + ' / -2.0)';
        gone.paddingTop = '0px';
        gone.marginBottom = 'calc(' + gapY + ' / -2.0)';
        gone.paddingBottom = '0px';
      } else {
        var gap_0 = parentStyle.columnGap;
        var tmp_34;
        var tmp_35;
        if (parent.classList.contains('optimized')) {
          var tmp_36 = asSequence(until(0, parent.children.length));
          // Inline function 'kotlin.sequences.find' call
          var tmp0_2 = mapNotNull(tmp_36, showHideWorker$lambda$slambda$lambda_3(parent));
          var tmp$ret$59;
          $l$block_3: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s_11 = tmp0_2.m1();
            while (_iterator__ex2g4s_11.n1()) {
              var element_8 = _iterator__ex2g4s_11.o1();
              if (!element_8.hidden) {
                tmp$ret$59 = element_8;
                break $l$block_3;
              }
            }
            tmp$ret$59 = null;
          }
          var tmp$ret$60 = tmp$ret$59;
          tmp_35 = !equals(tmp$ret$60, myElement_1);
        } else {
          tmp_35 = false;
        }
        if (tmp_35) {
          var tmp_37 = asSequence(downTo(parent.children.length - 1 | 0, 0));
          // Inline function 'kotlin.sequences.find' call
          var tmp0_3 = mapNotNull(tmp_37, showHideWorker$lambda$slambda$lambda_4(parent));
          var tmp$ret$62;
          $l$block_4: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s_12 = tmp0_3.m1();
            while (_iterator__ex2g4s_12.n1()) {
              var element_9 = _iterator__ex2g4s_12.o1();
              if (!element_9.hidden) {
                tmp$ret$62 = element_9;
                break $l$block_4;
              }
            }
            tmp$ret$62 = null;
          }
          var tmp$ret$63 = tmp$ret$62;
          tmp_34 = equals(tmp$ret$63, myElement_1);
        } else {
          tmp_34 = false;
        }
        var doPrevMargin_0 = tmp_34;
        if (doPrevMargin_0) {
          full.marginTop = gap_0;
          gone.marginTop = '0px';
        }
        gone.marginBottom = '0px';
        gone.paddingBottom = '0px';
      }
      if (weighted == null) {
        var fullHeight = childStyle.height;
        gone.height = '0px';
        gone.minHeight = '0px';
        gone.maxHeight = '0px';
        full.height = fullHeight;
        full.minHeight = fullHeight;
        full.maxHeight = fullHeight;
      }
    }
    if (weighted == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      full.flexGrow = weighted;
      full.flexShrink = weighted;
      gone.flexGrow = '0';
      gone.flexShrink = '0';
    }
    // Inline function 'kotlin.takeUnless' call
    var tmp_38;
    if (!goneTransform.i1()) {
      tmp_38 = goneTransform;
    } else {
      tmp_38 = null;
    }
    if (tmp_38 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
    }
    // Inline function 'kotlin.takeUnless' call
    var tmp_39;
    if (!fullTransform.i1()) {
      tmp_39 = fullTransform;
    } else {
      tmp_39 = null;
    }
    if (tmp_39 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
    }
    var tmp_40 = (!(before == null) ? !(before == null) : false) ? before : THROW_CCE();
    var tmp_41 = (!(after == null) ? !(after == null) : false) ? after : THROW_CCE();
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs_0 = pastRatios.p3(on_1);
    var tmp_42;
    if (tmp0_elvis_lhs_0 == null) {
      tmp_42 = 1.0;
    } else {
      tmp_42 = tmp0_elvis_lhs_0;
    }
    // Inline function 'kotlin.also' call
    var this_4 = tmp_42;
    var tmp0_safe_receiver_5 = get_log();
    if (tmp0_safe_receiver_5 == null)
      null;
    else {
      var tmp1_safe_receiver_4 = singleOrNull(on_1.oba());
      tmp0_safe_receiver_5.abn(['Past for ' + (tmp1_safe_receiver_4 == null ? null : tmp1_safe_receiver_4.fb9()) + ' is ' + this_4]);
    }
    var tmp$ret$78 = new (OngoingAnimation())(on_1, tmp_40, tmp_41, goal_1, 1.0 - this_4);
    destination_4.v(tmp$ret$78);
  }
  var queuedAnimations = destination_4;
  var tmp9_safe_receiver = $this.odr_1;
  var tmp_43 = tmp9_safe_receiver;
  if ((tmp_43 == null ? null : new (Duration())(tmp_43)) == null)
    null;
  else {
    var tmp_44 = tmp9_safe_receiver;
    // Inline function 'kotlin.let' call
    var it_3 = (tmp_44 == null ? null : new (Duration())(tmp_44)).nj_1;
    var tmp_45 = delay(it_3, $completion);
    if (tmp_45 === get_COROUTINE_SUSPENDED())
      tmp_45 = yield tmp_45;
  }
  var tmp10_safe_receiver = get_log();
  if (tmp10_safe_receiver == null)
    null;
  else {
    tmp10_safe_receiver.abn(['// Revert to what we were.']);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_13 = get_showHideAnimating().d2().m1();
  while (_iterator__ex2g4s_13.n1()) {
    var element_10 = _iterator__ex2g4s_13.o1();
    element_10.f2().mdr();
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_14 = beforeVisibility.m1();
  while (_iterator__ex2g4s_14.n1()) {
    var element_11 = _iterator__ex2g4s_14.o1();
    var tmp_46 = element_11.af_1.tb5_1.vb3_1;
    (tmp_46 instanceof HTMLElement ? tmp_46 : THROW_CCE()).hidden = element_11.bf_1;
    var tmp0_safe_receiver_6 = get_log();
    if (tmp0_safe_receiver_6 == null)
      null;
    else {
      var tmp1_safe_receiver_5 = singleOrNull(element_11.af_1.oba());
      tmp0_safe_receiver_6.abn(['View ' + (tmp1_safe_receiver_5 == null ? null : tmp1_safe_receiver_5.fb9()) + ' -> ' + element_11.bf_1]);
    }
    var tmp_47 = element_11.af_1.rb6_1;
    var tmp2_safe_receiver_1 = tmp_47 instanceof RowOrCol() ? tmp_47 : null;
    if (tmp2_safe_receiver_1 == null)
      null;
    else {
      tmp2_safe_receiver_1.vb8();
    }
  }
  var tmp11_safe_receiver = $this.odr_1;
  var tmp_48 = tmp11_safe_receiver;
  if ((tmp_48 == null ? null : new (Duration())(tmp_48)) == null)
    null;
  else {
    var tmp_49 = tmp11_safe_receiver;
    // Inline function 'kotlin.let' call
    var it_4 = (tmp_49 == null ? null : new (Duration())(tmp_49)).nj_1;
    var tmp_50 = delay(it_4, $completion);
    if (tmp_50 === get_COROUTINE_SUSPENDED())
      tmp_50 = yield tmp_50;
  }
  var tmp12_safe_receiver = get_log();
  if (tmp12_safe_receiver == null)
    null;
  else {
    tmp12_safe_receiver.abn(['// Begin animating the views in question.']);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_15 = queuedAnimations.m1();
  while (_iterator__ex2g4s_15.n1()) {
    var element_12 = _iterator__ex2g4s_15.o1();
    element_12.kdr();
  }
  var tmp13_safe_receiver = $this.odr_1;
  var tmp_51 = tmp13_safe_receiver;
  if ((tmp_51 == null ? null : new (Duration())(tmp_51)) == null)
    null;
  else {
    var tmp_52 = tmp13_safe_receiver;
    // Inline function 'kotlin.let' call
    var it_5 = (tmp_52 == null ? null : new (Duration())(tmp_52)).nj_1;
    var tmp_53 = delay(it_5, $completion);
    if (tmp_53 === get_COROUTINE_SUSPENDED())
      tmp_53 = yield tmp_53;
  }
  return Unit_instance;
}
function showHideWorker$lambda$slambda$lambda(it) {
  return it.rb6_1 == null || it.oba().i1() || it.tb5_1.oba().i1() || it.tb5_1.vb3_1 == null;
}
function showHideWorker$lambda$slambda$lambda_0(it) {
  var tmp = it.e2().tb5_1.vb3_1;
  return !(tmp instanceof HTMLElement ? tmp : THROW_CCE()).hidden;
}
function showHideWorker$lambda$slambda$lambda_1($parent) {
  return (it) => {
    // Inline function 'org.w3c.dom.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $parent.children[it];
    return tmp instanceof HTMLElement ? tmp : null;
  };
}
function showHideWorker$lambda$slambda$lambda_2($parent) {
  return (it) => {
    // Inline function 'org.w3c.dom.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $parent.children[it];
    return tmp instanceof HTMLElement ? tmp : null;
  };
}
function showHideWorker$lambda$slambda$lambda_3($parent) {
  return (it) => {
    // Inline function 'org.w3c.dom.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $parent.children[it];
    return tmp instanceof HTMLElement ? tmp : null;
  };
}
function showHideWorker$lambda$slambda$lambda_4($parent) {
  return (it) => {
    // Inline function 'org.w3c.dom.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = $parent.children[it];
    return tmp instanceof HTMLElement ? tmp : null;
  };
}
var showHideWorker$lambda$slambdaClass;
function showHideWorker$lambda$slambda() {
  if (showHideWorker$lambda$slambdaClass === VOID) {
    class $ {
      constructor($showHideQueue, $delayLevel) {
        this.ndr_1 = $showHideQueue;
        this.odr_1 = $delayLevel;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    showHideWorker$lambda$slambdaClass = $;
  }
  return showHideWorker$lambda$slambdaClass;
}
function showHideWorker$lambda$slambda_0($showHideQueue, $delayLevel) {
  var i = new (showHideWorker$lambda$slambda())($showHideQueue, $delayLevel);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_modifiers_commonHtml_js_kt_9nzjen;
function _init_properties_modifiers_commonHtml_js_kt__3eylqb() {
  if (!properties_initialized_modifiers_commonHtml_js_kt_9nzjen) {
    properties_initialized_modifiers_commonHtml_js_kt_9nzjen = true;
    showHideAnimating = HashMap().n8();
    showHideQueue = null;
    log = null;
    showHideWorker = showHideWorker$lambda;
  }
}
//region block: exports
export {
  nativeAnimateHide as nativeAnimateHide1gje1vrdzq766,
  nativeAnimateShow as nativeAnimateShow1mpbjsmv28ail,
};
//endregion

//# sourceMappingURL=modifiers.commonHtml.js.mjs.map
